import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const quoteApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllQuotes: builder.mutation({
      query: ({ body }) => ({
        url: `${END_POINTS.getAllQuotes}`,
        method: "POST",
        body,
      }),
    }),

    revertQuote: builder.mutation({
      query: ({ body, id }) => ({
        url: `${END_POINTS.revertQuote}${id}/`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const { useGetAllQuotesMutation, useRevertQuoteMutation } = quoteApi;
